/**
 * Strip duplicate country code from a phone number.
 * If user types "+201011277411" and selected code is "+20",
 * returns "1011277411" (just the local number).
 */
export function stripDuplicateCountryCode(phone: string, selectedCode: string): string {
  if (!phone || !selectedCode) return phone;
  const cleaned = phone.trim();

  // If phone starts with the selected code, strip it
  if (cleaned.startsWith(selectedCode)) {
    return cleaned.substring(selectedCode.length).trim();
  }

  // If phone starts with the code digits without "+" (e.g., "20" when code is "+20")
  const codeDigits = selectedCode.replace('+', '');
  if (cleaned.startsWith(codeDigits) && cleaned.length > codeDigits.length + 6) {
    return cleaned.substring(codeDigits.length).trim();
  }

  return cleaned;
}

/**
 * Auto-detect country code from a phone number that starts with "+".
 * Returns the matching code from the provided list, or null.
 */
export function autoDetectCountryCode(phone: string, codeList: string[]): string | null {
  if (!phone || !phone.startsWith('+')) return null;

  // Sort codes by length descending so +971 matches before +97
  const sorted = [...codeList].sort((a, b) => b.length - a.length);
  for (const code of sorted) {
    if (phone.startsWith(code)) return code;
  }
  return null;
}
